import { NgModule } from '@angular/core';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import {AuthGuard} from "./services/authguard.service";
import {LayoutMasterComponent} from "./components/layouts/layout-master/layout-master.component";
import {SigninComponent} from "./components/signin/signin.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {RegistrationComponent} from "./components/registration/registration.component";
import {RegistryComponent} from "./components/registry/registry.component";
import {WorkComponent} from "./components/work/work.component";
import {StudyComponent} from "./components/study/study.component";
import { SettingsComponent } from './components/settings/settings.component';
import {PreferencesComponent} from "./components/preferences/preferences.component";
import { ForgotComponent } from './components/forgot/forgot.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import {DocumentComponent} from "./components/document/document.component";
import { AnnunciComponent } from './components/annunci/annunci.component';
import {DetailsComponent} from "./components/annunci/details/details.component";


export const AppRoutes: Routes =
  [
    {
      path: 'signin',
      component: SigninComponent,
    },
    {
      path: 'signin/:code/:userId',
      component: SigninComponent,
    },
    {
      path: 'signin/:code/:userId/:IdAnnuncio',
      component: SigninComponent,
    },
    {
      path: 'registration',
      component: RegistrationComponent,
    },
    {
      path: 'forgot',
          component: ForgotComponent,

    },
    {
      path: 'forgot/:code',
      component: ForgotComponent,
    },

    {
      path: 'confirm',
      component: ConfirmComponent,
    },
    { path: '', pathMatch: 'full', redirectTo: 'signin' },
    {
      path: '',
      component: LayoutMasterComponent,
      canActivate : [AuthGuard],
      children: [
        {
          path: 'dashboard',
          component: DashboardComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'registry',
          component: RegistryComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'work',
          component: WorkComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'study',
          component: StudyComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'preferences',
          component: PreferencesComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'annunci',
          component: AnnunciComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'annunci/:code',
          component: AnnunciComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'settings',
          component: SettingsComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
        {
          path: 'document',
          component: DocumentComponent,
          canActivate : [AuthGuard],
          data: { preload: true, delay: false }
        },
      ],
    },
    { path: '**', redirectTo: '' },
  ];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
